import "../App.css";

import { React, useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/joy/Button";
import { Form, Formik, Field, ErrorMessage } from "formik";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import background from "../login_bg.jpg";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import useAuth from "../hooks/useAuth";
import * as Yup from "yup";
import Axios from "../api/Axios";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Avatar,
  Grid,
  Paper,
  TextField,
  Typography,
  IconButton,
  FormControlLabel,
  createTheme,
  InputAdornment,
  Box,
  Checkbox,
} from "@mui/material";

const theme = createTheme();

const avatarStyle = { backgroundColor: "green", marginTop: "1vh" };

const titleStyle = { color: "#8d4004" };

const Login = () => {
  const { setAuth, persist, setPersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const imgStyle = {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "100vh",
  };

  const buttonStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const usernameStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const passwordStyle = {
    marginLeft: "1vh",
    marginTop: "2.5vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const typographyStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };

  const initialValues = {
    username: "",
    password: "",
  };
  const validationSchema = Yup.object().shape({
    // username: Yup.string().email('Please enter valid email').required('Required'),
    username: Yup.string()
      /* .min(10, "Too Short!")
      .max(11, "Too Long!") */
      .required("Required")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
        message: "Please enter valid email",
        excludeEmptyString: false,
      }),
    /* .matches(/^[0-9]\d{9}$/, {
        message: "Please enter valid phone number",
        excludeEmptyString: false,
      }), */
    password: Yup.string().required("Required"),
  });

  const LOGIN_URL = "/api/v1/login";
  const onSubmit = async (values, props) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });

    const username = values.username;
    const password = values.password;

    try {
      const response = await Axios.post(
        LOGIN_URL,
        { username, password },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      //console.log(from);
      //console.log(response.data.message);

      var shouldLogin = false;
      const roleObjects = response.data.data.user.roles;
      var roles = [];
      for (var i = 0; i < roleObjects.length; i++) {
        if (roleObjects[i].id === 2) {
          shouldLogin = true;
        }
        roles.push(roleObjects[i].id);
      }

      if (!shouldLogin) {
        setConfirmDialog({
          isOpen: true,
          title: "Login Failed",
          subTitle: "User not authorised.",
          action: "Retry",
          onConfirm: { onSubmit },
        });
        return;
      }

      const id = response.data.data.user.id;
      const accessToken = response.data.data.access_token;
      const refreshToken = response.data.data.refresh_token;
      const tenantId = response.data.data.user.managerTenant.id;

      //console.log(roles);

      setAuth({
        id,
        username,
        password,
        roles,
        accessToken,
        refreshToken,
        tenantId,
      });

      // clear input fields
      props.resetForm();
      props.setSubmitting(false);

      // Navigate home
      // navigate('sidenav')

      navigate(from, { replace: true });

      /* setNotify({
                isOpen: true,
                message: response.data.message,
                type: 'success'
            }) */
    } catch (error) {
      //console.log(from);
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        const statusCode = errorData.httpStatusCode;
        if (statusCode === 412) {
          navigate("/new-password", {
            replace: true,
            state: {
              password: password,
              username: username,
            },
          });
        }
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      setConfirmDialog({
        isOpen: true,
        title: "Login Failed",
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <div style={imgStyle}>
      <Box sx={{ display: "flex" }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Paper
            elevation={10}
            sx={{
              marginLeft: { xs: 8, sm: 20, md: 28, lg: 74, xl: 64 }, // xs=iPhone SE; sm=iPad Mini; md=iPad pro; lg=Nest Hub Max
              marginRight: { xs: 7, sm: 20, md: 28, lg: 74, xl: 64 },
              marginTop: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
              marginBottom: 4,
              paddingLeft: theme.spacing(2),
              paddingTop: theme.spacing(2),
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(2),
            }}
          >
            <Grid align="center">
              <Avatar style={avatarStyle}>
                <LockOutlinedIcon></LockOutlinedIcon>
              </Avatar>

              <h2 style={titleStyle}>BuuKipa Tenant</h2>
              <h2>Sign In</h2>

              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form>
                    {/* <Field
                      as={TextField}
                      label="Phone number"
                      name="username"
                      placeholder="E.g. 0722..."
                      style={usernameStyle}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="username">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                    /> */}

                    <Field
                      as={TextField}
                      label="Email"
                      name="username"
                      placeholder="E.g. use@mail.com"
                      style={usernameStyle}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="username">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                    />

                    <Field
                      as={TextField}
                      label="Password"
                      name="password"
                      placeholder="Enter password"
                      style={passwordStyle}
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="password">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <FormControlLabel
                      control={<Checkbox name="persist" checked={persist} />}
                      name="persist"
                      onChange={togglePersist}
                      label="Trust This Device"
                      sx={{
                        mt: "2vh",
                      }}
                    />

                    <Button
                      type="submit"
                      color="primary"
                      fullWidth
                      loading={props.isSubmitting}
                      loadingPosition="start"
                      variant="solid"
                      style={buttonStyle}
                    >
                      {props.isSubmitting ? "Processing" : "Sign In"}
                    </Button>
                  </Form>
                )}
              </Formik>

              <Typography align="center" style={typographyStyle}>
                {/* Endpoint to route to Forgot password component */}
                <Link to="/otp">Forgot password?</Link>
              </Typography>
            </Grid>
          </Paper>

          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Grid>
      </Box>
    </div>
  );
};

export default Login;
